var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 120,
    viewBox: "0 0 224 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5280_18623)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.334 45.8853H116.361C119.085 45.8853 121.462 46.4476 123.496 47.5751C125.527 48.7026 127.088 50.2701 128.178 52.2746C129.268 54.2821 129.813 56.5838 129.813 59.1856C129.813 61.7874 129.268 64.0891 128.178 66.0965C127.088 68.1039 125.527 69.6685 123.496 70.796C121.465 71.9236 119.088 72.4859 116.361 72.4859H108.334V45.8853ZM116.361 69.482C119.507 69.482 122.001 68.5788 123.849 66.7695C125.693 64.9602 126.616 62.4342 126.616 59.1885C126.616 55.9428 125.693 53.4168 123.849 51.6074C122.004 49.7981 119.507 48.8949 116.361 48.8949H111.457V69.4791H116.361V69.482Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.675 72.2674C133.586 71.7226 132.744 70.9738 132.149 70.0182C131.555 69.0655 131.258 67.9816 131.258 66.7667C131.258 64.7592 132.012 63.1947 133.525 62.0671C135.034 60.9396 136.942 60.3773 139.247 60.3773C140.386 60.3773 141.444 60.5026 142.422 60.7502C143.401 60.9979 144.15 61.2834 144.672 61.6039V60.453C144.672 59.04 144.176 57.9066 143.186 57.0529C142.195 56.1993 140.942 55.771 139.433 55.771C138.367 55.771 137.391 56.0011 136.496 56.4586C135.605 56.916 134.9 57.5541 134.378 58.3728L132.001 56.5897C132.744 55.4505 133.766 54.5589 135.066 53.915C136.365 53.2712 137.81 52.9478 139.395 52.9478C141.971 52.9478 143.996 53.6237 145.47 54.9727C146.944 56.3245 147.681 58.163 147.681 60.4909V72.4918H144.672V69.7793H144.523C143.978 70.697 143.16 71.475 142.07 72.1189C140.98 72.7627 139.754 73.0861 138.39 73.0861C137.006 73.0861 135.768 72.8123 134.675 72.2674ZM141.662 69.4821C142.577 68.9373 143.308 68.206 143.853 67.2911C144.398 66.3763 144.672 65.3711 144.672 64.2814C144.077 63.8852 143.346 63.5618 142.481 63.3141C141.613 63.0665 140.698 62.9412 139.73 62.9412C137.997 62.9412 136.689 63.2996 135.812 64.0192C134.932 64.7389 134.492 65.6683 134.492 66.8046C134.492 67.8447 134.888 68.6867 135.681 69.3306C136.473 69.9745 137.475 70.2979 138.69 70.2979C139.754 70.2979 140.747 70.0269 141.662 69.4821Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.015 53.8393H154.024V56.849H154.173C154.619 55.7331 155.373 54.8678 156.44 54.2472C157.503 53.6295 158.669 53.3178 159.933 53.3178C160.478 53.3178 160.935 53.3557 161.308 53.4285V56.6625C160.886 56.5635 160.318 56.5139 159.598 56.5139C157.987 56.5139 156.681 57.0471 155.679 58.1106C154.677 59.1769 154.173 60.5638 154.173 62.2711V72.7861H151.015V53.8393ZM170.629 72.7074C169.973 72.4568 169.422 72.116 168.974 71.6847C168.478 71.2069 168.105 70.6504 167.858 70.0211C167.61 69.3918 167.485 68.6226 167.485 67.7136V56.4032H164.178V53.5421H167.485V48.1929H170.643V53.5421H175.249V56.4032H170.643V66.9619C170.643 68.0253 170.841 68.8091 171.238 69.316C171.707 69.8725 172.388 70.1522 173.28 70.1522C173.997 70.1522 174.693 69.9425 175.36 69.52V72.6054C174.987 72.7773 174.611 72.9026 174.227 72.9784C173.842 73.0541 173.353 73.0891 172.758 73.0891C171.998 73.0862 171.287 72.958 170.629 72.7074Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.6363 71.7401L49.8536 64.9574C49.0495 64.1299 48.5483 62.9645 48.5483 61.8253C48.5483 61.298 48.8455 60.4734 49.0699 59.9985L55.3311 46.9546L56.6363 71.7401Z",
    fill: "#01579B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8573 48.2599L73.0745 41.4771C72.4831 40.8828 71.2477 40.1719 70.2047 40.1719C69.3073 40.1719 68.4274 40.3525 67.8564 40.6934L55.334 46.9546L79.8573 48.2599Z",
    fill: "#40C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7242 79.8279H81.1624V72.783L68.8993 68.8701L57.6821 72.783L64.7242 79.8279Z",
    fill: "#40C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.334 68.0894C55.334 70.1814 55.5962 70.6971 56.6393 71.743L57.6823 72.7861H81.1625L69.6832 59.7421L55.334 46.9575V68.0894Z",
    fill: "#29B6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2037 46.9546H55.3311L81.1596 72.7831H88.2045V56.6072L79.8572 48.2599C78.686 47.0828 77.643 46.9546 76.2037 46.9546Z",
    fill: "#01579B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.8985 72.0023C55.8555 70.9534 55.5933 69.922 55.5933 68.0894V47.2168L55.3311 46.9546V68.0865C55.334 69.922 55.334 70.429 56.8985 72.0023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.9453 56.3477V72.5236H80.9004L81.1626 72.7829H88.2076V56.6099L87.9453 56.3477Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M79.8573 48.2599C78.5636 46.9662 77.5031 46.9546 75.9444 46.9546H55.334L55.5962 47.2168H75.9473C76.7223 47.2168 78.6889 47.0857 79.8573 48.2599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.9453 56.3479L79.8573 48.2599L73.0745 41.4771C72.4831 40.8828 71.2478 40.1719 70.2047 40.1719C69.3073 40.1719 68.4274 40.3525 67.8564 40.6934L55.334 46.9546L49.0728 59.9985C48.8485 60.4734 48.5513 61.298 48.5513 61.8253C48.5513 62.9645 49.0524 64.1299 49.8565 64.9574L56.109 71.1632C56.2576 71.3468 56.4324 71.5332 56.6422 71.7401L56.9044 72.0023L57.6881 72.7861L64.4709 79.5688L64.7331 79.831H80.9091H81.1713V72.7861H88.2162V72.7686V56.6101L87.9453 56.3479Z",
    fill: "url(#paint0_radial_5280_18623)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5280_18623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.3823 60.0004) scale(19.831)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5280_18623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.904,
    height: 40,
    fill: "white",
    transform: "translate(48 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/dart.7f85a2a31353181c7360f41c23df9e24.svg";
export { ForwardRef as ReactComponent };